export default __webpack_public_path__ + "static/media/Emerald-hide Shoes.b9bae44d.jpg";